import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpBaseService } from "@gea-waldviertler-website/shop-lib";
import {
  DistinctProductFilter,
  DistinctProductInterfaceType,
  ProductConfigResultInterface,
  ProductPageResponseInterface,
  ProductSliderResponseInterface
} from "@gea-waldviertler-website/gea-models";

@Injectable()
export class HttpProductService extends HttpBaseService {

  getProduct(slug: string): Observable<ProductPageResponseInterface> {
    let url: string = this.getMainApiBaseUrl() + "/product/" + slug
    return this.http.get<ProductPageResponseInterface>(url)
  }

  getDimensionOptions(productSlug: string, selected: number[]): Observable<ProductConfigResultInterface> {
    let slug = selected.join(',')
    let url: string = this.getMainApiBaseUrl() + "/product/configure/" + productSlug + '?selectedOptions=' + slug

    return this.http.get<ProductConfigResultInterface>(url)
  }

  getProducts(distinctProducts: DistinctProductFilter[]) : Observable<ProductSliderResponseInterface> {
    let url: string = this.getMainApiBaseUrl() + `/product/all`
    return this.http.post<ProductSliderResponseInterface>(url, { products: distinctProducts })
  }

  registerRemindAvailibility(email: string, distinctProduct?: DistinctProductInterfaceType) : Observable<any> {
    let url: string = this.getMainApiBaseUrl() + `/product/remind-availibility`
    return this.http.post<any>(url, { email: email, product: distinctProduct })
  }
}
